import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternshipTypePipe } from './internship-type-translate.pipe';



@NgModule({
  declarations: [InternshipTypePipe],
  imports: [
    CommonModule
  ],
  exports: [InternshipTypePipe],
})
export class InternshipTypePipeModule { }
